export const FETCH_ADD_PROJECT_TEMPLATE_TASK_REQUEST = 'FETCH_ADD_PROJECT_TEMPLATE_TASK_REQUEST'
export const FETCH_ADD_PROJECT_TEMPLATE_TASK_SUCCESS = 'FETCH_ADD_PROJECT_TEMPLATE_TASK_SUCCESS'
export const FETCH_ADD_PROJECT_TEMPLATE_TASK_FALUIRE = 'FETCH_ADD_PROJECT_TEMPLATE_TASK_FALUIRE'
